export const SERVER_URL = 'http://127.0.0.1:8000'

export const BASE_URL = 'https://aman7531.pythonanywhere.com/api'